export const SECURE_EXPORTS_URL: string = '/secure-exports';

export function isSecureDownload(url: string): boolean {
    return url.includes(SECURE_EXPORTS_URL);
}
